<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <a-form ref="ruleForm" :model="form" :label-col="labelCol" :rules="rules" :wrapper-col="wrapperCol" :scrollToFirstError="true">
        <a-form-item ref="image_url" label="产品图片" name="image_url">
          <div class='ant-upload-list ant-upload-list-picture-card' v-if='form.cover_image_url'>
            <div class='ant-upload-list-picture-card-container'>
              <span>
                <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                  <div class="ant-upload-list-item-info">
                    <img :src="info.picdomain+'/'+form.cover_image_url" class='ant-upload-list-item-image' />
                  </div>
                </div>
              </span>
            </div>
          </div>
        </a-form-item>
        <a-form-item ref="product_name" label="产品名称" name="product_name">
          {{form.product_name}}
        </a-form-item>
        <a-form-item label="产品分组" name='cat_id' ref="cat_id">
          <a-cascader :options="cateList" :field-names="{ label: 'name', value: 'id', children: 'children' }" 
          v-model:value="form.cat_id" placeholder="请选择产品分组" change-on-select style="width:300px;margin-right:10px" /> <a href="/onlineOrder/productManage/cate" target="_blank">新建分组</a>
        </a-form-item>
        <a-form-item ref="point_price" label="单件支付积分" name="point_price" v-if="form.spec_type==1" help="(用户原价支付商品积分)">
          <a-input-number v-model:value="form.point_price" :precision='0' :min="1"></a-input-number>
        </a-form-item>
        <a-form-item ref="box_point_price" label="整箱支付积分" name="box_point_price" v-if="form.spec_type==1" help="(用户原价支付商品积分)">
          <a-input-number v-model:value="form.box_point_price" :precision='0' :min="1"></a-input-number>
        </a-form-item>
        <!--产品规格-->
        <a-form-item ref="spec_many" label="产品规格" name="spec_many" :wrapper-col="{ span: 20}" v-if="form.spec_type==2">
          <a-table bordered :data-source="form.product_sku" :columns="columns" :pagination='false'>
            <template #name="{ record }">
              <p class="width-50"><span v-for="(v,k) in record.propertyList" :key='k'>{{v.value}}{{record.propertyList[k+1]?'__':''}}</span></p>
            </template>
            <template #imageUrl="{ record }">
              <div>
                <div class='ant-upload-list ant-upload-list-picture-card' v-if='record.image_url'>
                  <div class='ant-upload-list-picture-card-container'>
                    <span>
                      <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                        <div class="ant-upload-list-item-info">
                          <img :src="info.picdomain+'/'+record.image_url" class='ant-upload-list-item-image' />
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <template #point_price="{ record }">
              <a-input-number v-model:value="record.point_price" :precision='0' :min="1"></a-input-number>
            </template>
            <template #box_point_price="{ record }">
              <a-input-number v-model:value="record.box_point_price" :precision='0' :min="1"></a-input-number>
            </template>
            <template #number="{ record }">
              {{record.sku_sn}}
            </template>
          </a-table>
        </a-form-item>
        <a-form-item ref="sort" label="列表排序" name="sort" help="数字越大排名越前">
          <a-input-number v-model:value="form.sort" :precision='0' :min="0"></a-input-number>
        </a-form-item>
        <a-form-item ref="sort" label="商品状态" name="status">
          <a-radio-group v-model:value="form.status">
            <a-radio :value="0">
              下架
            </a-radio>
            <a-radio :value="1">
              上架
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item :wrapperCol="{offset:4}">
          <a-button type="primary" @click="onSubmit">保存</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import store from "@/store";
import { message } from "ant-design-vue";
import {
  getBaseProductDetail,
  getGoodsCategory,
  createProduct,
} from "@/api/online";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defForm = {
  product_id: "",
  cat_id: [],
  status: 1,
  point_price:null,
  box_point_price:null,
  sort: 0,
  goods_sku_data: [],
};
export default {
  setup() {
    //pass
    const form = ref(JSON.parse(JSON.stringify({ ...defForm })));
    const state = reactive({
      detail: defForm,
      info: store.state.user.info,
      typeLoading: false,
      SetStockNum: 0,
      SetPrice: 0,
      current: 0,
      content: "",
      dataSource: [],
      targetKeys: [],
      fileList: [],
      loading: false,
      imageUrl: "",
      previewVisible: false,
      previewImage: "",
      labelCol: { span: 4 },
      wrapperCol: { span: 15 },
      rules: {
        cat_id: [
          {
            required: true,
            message: "请选择分组",
            type: "array",
          },
        ],
        point_price: [
          {
            required: true,
            message: "请输入单件支付积分",
          },
        ],
        box_point_price: [
          {
            required: true,
            message: "请输入整箱支付积分",
          },
        ],
      },
    });
    const ruleForm = ref();
    const momentTime = inject("momentTime");
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    const columns = ref([
      {
        title: "规格图片",
        dataIndex: "imageUrl",
        slots: { customRender: "imageUrl" },
      },
      {
        title: "价格(元)",
        dataIndex: "product_price",
        key: "product_price",
      },

      {
        title: "单件支付积分",
        dataIndex: "point_price",
        slots: { customRender: "point_price" },
      },
      {
        title: "整箱支付积分",
        dataIndex: "box_point_price",
        slots: { customRender: "box_point_price" },
      },
      {
        title: "商品编号",
        dataIndex: "number",
        slots: { customRender: "number" },
      },
    ]);
    // 初始化
    const init = async () => {
      // 获取页面参数
      if ($route.query.product_id) {
        // 获取详情
        getBaseProductDetail($route.query.product_id).then((res) => {
          var result = res.data.data;
          form.value = result;
          form.value.status=1
          //  多规格组装表头
          if (form.value.spec_type == 2) {
            var spec_value = form.value.spec_value;
            var column = [];
            spec_value.forEach((element, k) => {
              column.push({
                title: element.spec_name,
                dataIndex: "skus",
                customRender: ({ record }) => {
                  return record.spec_value.split("_")[k];
                },
              });
            });
            columns.value = column.concat(columns.value);
            // 规格生成字段
            form.value.product_sku.map((v) => {
              v["box_point_price"] = null;
              v["point_price"] = null;
              v["sku"] = v.sku_sn;
            });
          }
          // 获取分类
          getCate();
        });
      }
    };
    const cateList = ref([]);
    const getCate = async () => {
      let cateResult = await getGoodsCategory()
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(cateResult)) {
        if(cateResult.data.length){
            cateList.value = cateResult.data;
        }
      }
    };
    init();
    const router = inject("$router");
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async (e) => {
          let json = {};
          var goods_sku_data = [];
          if (form.value.spec_type == 2) {
            // 多规格
            var flag = true;
            form.value.product_sku.forEach((element) => {
              goods_sku_data.push({
                sku: element.sku,
                point_price: element.point_price,
                box_point_price: element.box_point_price,
              });
              if (!element.point_price || !element.box_point_price) {
                flag = false;
              }
              if (!flag) {
                return message.error("请输入完整支付积分");
              }
            });
          } else {
            goods_sku_data = [
              {
                sku: 0,
                point_price: form.value.point_price,
                box_point_price: form.value.box_point_price,
              },
            ];
          }
          json = {
            ...e,
            product_id: $route.query.product_id,
            cat_id: form.value.cat_id[form.value.cat_id.length - 1],
            goods_sku_data,
          };
          var result = await createProduct(json).then((res) => res.data);
          if (iscode(result, true)) {
            router.push({ path: "/onlineOrder/productManage/index" });
            setTimeout(() => {
              ruleForm.value.resetFields();
              form.value = {};
            }, 100);
          }
        })
        .catch((error) => {
          state.current--;
        });
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      cateList,
      columns,
    };
  },
};
</script>
<style lang="less" >
@import url("@/style/app-warp/app-warp.less");
</style>
<style lang="less" scoped>
.ant-row {
  margin-bottom: 40px;
}

.editorContent {
  display: flex;
  .detailContent {
    background-image: url("../../../../assets/images/iphone.png");
    width: 327px;
    height: 727px;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 50px;
    word-break: break-all;
    padding: 50px 23px 10px;
  }
}

.cateItem {
  width: 195px;
  height: 73px;
  text-align: center;
  line-height: 73px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  margin-right: 26px;

  > label {
    width: 195px;
    height: 73px;
    display: block;
    position: relative;
    border: 1px solid #83c8dd;
    border-radius: 5px;
    overflow: hidden;
  }

  .current {
    display: none;
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    line-height: 0;
    font-size: 0;
    pointer-events: none;
    border: 20px solid #83c8dd;
    border-left-color: transparent;
    border-top-color: transparent;
    right: -1px;
    bottom: -1px;

    span {
      position: absolute;
      font-size: 14px;
      color: #fff;
      margin-top: 8px;
      transform: rotate(10deg);
    }
  }

  input:checked ~ label {
    border: 1px solid #83c8dd;

    .current {
      display: block;
    }
  }
}

.otherItem {
  position: relative;
  border: 1px solid #83c8dd;
  border-radius: 5px;
  .otherList {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    display: none;
    border: 1px solid #83c8dd;
    position: absolute;
    border-top: none;
    width: 287px;
    overflow: scroll;
    height: 100px;
    right: -1px;
    top: 79px;
    box-sizing: border-box;
    transition: display 1s;
    &::before {
      content: "";
      width: 92px;
      height: 1px;
      position: absolute;
      top: 0;
      background-color: #83c8dd;
      left: 0;
    }
  }
  .ant-radio-group {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
  }
  .white-line {
    position: absolute;
    background-color: #fff;
    right: -2px;
    top: -10px;
    width: 195px;
    height: 10px;
    box-sizing: border-box;
    border-left: 1px solid #83c8dd;
    border-right: 1px solid #83c8dd;
  }
  &:hover {
    border-bottom: none;
    height: 80px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    .otherList {
      display: block;
    }
  }
}
.ant-upload-list-item-image {
  width: 100%;
}
</style>
